import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType,
  WorkflowComponentParameterMode
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class QuadbinToParent extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.quadbintoparent',
        group: 'Spatial Indexes',
        title: 'Quadbin To Parent',
        description: `
        Add a new column named quadbin_parent with the value of the parent quadbin at a specific resolution.
        If required resolution is higher than quadbin column, than an "Invalid resolution" query error will be returned.
        `,
        starred: false,
        deprecated: false,
        tags: []
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'quadbin',
          type: WorkflowComponentParamType.Column,
          title: 'Quadbin index column',
          parent: 'source',
          dataType: [ColumnDataType.Number]
        },
        {
          name: 'resolution',
          type: WorkflowComponentParamType.Number,
          title: 'Resolution',
          min: 0,
          max: 26,
          mode: WorkflowComponentParameterMode.Slider
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    const namespace = connection.quoteName(envVars.analyticsToolboxDataset as string)
    const sourceT = connection.quoteName(params.source as string)

    if (connection.type === Provider.DatabricksRest) {
      return `SELECT /*+ REPARTITION(40) */
              QUADBIN_TOPARENT(
                ${params.quadbin},
                CAST(${params.resolution} AS INTEGER)
              ) quadbin_parent,
              *
            FROM ${sourceT}`
    } else {
      return `SELECT
        ${namespace}.QUADBIN_TOPARENT(
          ${params.quadbin},
          CAST(${params.resolution} AS INTEGER)
        ) quadbin_parent,
        *
      FROM
        ${sourceT}`
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  requiredAnalyticsToolboxVersion(provider: Provider): string | null {
    switch (provider) {
      default:
        return '1.0.0'
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getVersion(provider: Provider): string {
    switch (provider) {
      // leaved switch in case have to add more provider specific cases
      default:
        return '1.0.0'
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: 'quadbin_parent',
      type: ColumnDataType.Number
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Snowflake, Provider.Redshift, Provider.Postgres, Provider.DatabricksRest]
  }
}

export { QuadbinToParent }
